module.exports = __webpack_public_path__ + "img/pays.679fa296.png";